import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrButton.less';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

export const SR_BUTTON_THEME_ADOBE_YELLOW_TENANT_SCREENING_LISTING = 'SR_BUTTON_THEME_ADOBE_YELLOW_TENANT_SCREENING_LISTING'; // eslint-disable-line max-len
export const SR_BUTTON_THEME_ADOBE_BLUE_PROPERTY_DOCS = 'SR_BUTTON_THEME_ADOBE_BLUE_PROPERTY_DOCS';
export const SR_BUTTON_THEME_ADOBE_BLUE_BORDER_PROPERTY_DOCS = 'SR_BUTTON_THEME_ADOBE_BLUE_BORDER_PROPERTY_DOCS'; // eslint-disable-line max-len
export const SR_BUTTON_THEME_ADOBE_YELLOW = 'SR_BUTTON_THEME_ADOBE_YELLOW';
export const SR_BUTTON_THEME_ADOBE_BLUE = 'SR_BUTTON_THEME_ADOBE_BLUE';
export const SR_BUTTON_THEME_ADOBE_BLUE_INVERTED = 'SR_BUTTON_THEME_ADOBE_BLUE_INVERTED';
export const SR_BUTTON_THEME_ADOBE_BLUE_OUTLINE = 'SR_BUTTON_THEME_ADOBE_BLUE_OUTLINE';
export const SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY = 'SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY';
export const SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY_OUTLINE = 'SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY_OUTLINE';
export const SR_BUTTON_THEME_ADOBE_GREEN = 'SR_BUTTON_THEME_ADOBE_GREEN';
export const SR_BUTTON_THEME_ADOBE_GREY = 'SR_BUTTON_THEME_ADOBE_GREY';
export const SR_BUTTON_THEME_ADOBE_RED = 'SR_BUTTON_THEME_ADOBE_RED';
export const SR_BUTTON_THEME_ADOBE_ORANGE_INVERTED = 'SR_BUTTON_THEME_ADOBE_ORANGE_INVERTED';
export const SR_BUTTON_THEME_ADOBE_RED_INVERTED = 'SR_BUTTON_THEME_ADOBE_RED_INVERTED';
export const SR_BUTTON_THEME_ADOBE_RED_OUTLINE = 'SR_BUTTON_THEME_ADOBE_RED_OUTLINE';
export const SR_BUTTON_THEME_ADOBE_WHITE = 'SR_BUTTON_THEME_ADOBE_WHITE';
export const SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER = 'SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER';
export const SR_BUTTON_THEME_ADOBE_BLUE_BORDER = 'SR_BUTTON_THEME_ADOBE_BLUE_BORDER';
export const SR_BUTTON_THEME_ADOBE_TRANSPARENT_BLUE_BORDER = 'SR_BUTTON_THEME_ADOBE_TRANSPARENT_BLUE_BORDER';
export const SR_BUTTON_THEME_ADOBE_TRANSPARENT_RED_BORDER = 'SR_BUTTON_THEME_ADOBE_TRANSPARENT_RED_BORDER';
export const SR_BUTTON_THEME_BLUR = 'SR_BUTTON_THEME_BLUR';
export const SR_BUTTON_THEME_ASSEMBLY_LINE_BLUE = 'SR_BUTTON_THEME_ASSEMBLY_LINE_BLUE';
export const SR_BUTTON_THEME_TRANSPARENT = 'SR_BUTTON_THEME_TRANSPARENT';

const SR_BUTTON_THEME_TO_CLASSNAME_MAPPING = {
  [SR_BUTTON_THEME_ADOBE_YELLOW]: 'adobe-yellow',
  [SR_BUTTON_THEME_ADOBE_YELLOW_TENANT_SCREENING_LISTING]: 'adobe-yellow-tenant-screening-listing',
  [SR_BUTTON_THEME_ADOBE_BLUE_PROPERTY_DOCS]: 'adobe-blue-property-docs',
  [SR_BUTTON_THEME_ADOBE_BLUE_BORDER_PROPERTY_DOCS]: 'adobe-blue-border-property-docs',
  [SR_BUTTON_THEME_ADOBE_BLUE]: 'adobe-blue',
  [SR_BUTTON_THEME_ADOBE_BLUE_INVERTED]: 'adobe-blue-inverted',
  [SR_BUTTON_THEME_ADOBE_BLUE_OUTLINE]: 'adobe-blue-outline',
  [SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY]: 'adobe-blue-dark-navy',
  [SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY_OUTLINE]: 'adobe-blue-dark-navy-outline',
  [SR_BUTTON_THEME_ADOBE_GREEN]: 'adobe-green',
  [SR_BUTTON_THEME_ADOBE_GREY]: 'adobe-grey',
  [SR_BUTTON_THEME_ADOBE_RED]: 'adobe-red',
  [SR_BUTTON_THEME_ADOBE_ORANGE_INVERTED]: 'adobe-orange-inverted',
  [SR_BUTTON_THEME_ADOBE_RED_INVERTED]: 'adobe-red-inverted',
  [SR_BUTTON_THEME_ADOBE_RED_OUTLINE]: 'adobe-red-outline',
  [SR_BUTTON_THEME_ADOBE_WHITE]: 'adobe-white',
  [SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER]: 'adobe-white-blue-border',
  [SR_BUTTON_THEME_ADOBE_BLUE_BORDER]: 'adobe-blue-border',
  [SR_BUTTON_THEME_BLUR]: 'blur',
  [SR_BUTTON_THEME_ASSEMBLY_LINE_BLUE]: 'assembly-line-blue',
  [SR_BUTTON_THEME_ADOBE_TRANSPARENT_BLUE_BORDER]: 'adobe-transparent-blue-border',
  [SR_BUTTON_THEME_ADOBE_TRANSPARENT_RED_BORDER]: 'adobe-transparent-red-border',
  [SR_BUTTON_THEME_TRANSPARENT]: 'transparent',
};
const SR_BUTTON_THEMES = Object.keys(SR_BUTTON_THEME_TO_CLASSNAME_MAPPING);

export const SR_BUTTON_HEIGHT_SHORTER = 'SR_BUTTON_HEIGHT_SHORTER';
export const SR_BUTTON_HEIGHT_SHORT = 'SR_BUTTON_HEIGHT_SHORT';
export const SR_BUTTON_HEIGHT_MEDIUM = 'SR_BUTTON_HEIGHT_MEDIUM';
export const SR_BUTTON_HEIGHT_TALL = 'SR_BUTTON_HEIGHT_TALL';
export const SR_BUTTON_HEIGHT_EXTRA_TALL = 'SR_BUTTON_HEIGHT_EXTRA_TALL';
const SR_BUTTON_HEIGHT_TO_CLASSNAME_MAPPING = {
  SR_BUTTON_HEIGHT_SHORTER: 'height-shorter',
  SR_BUTTON_HEIGHT_SHORT: 'height-short',
  SR_BUTTON_HEIGHT_MEDIUM: 'height-medium',
  SR_BUTTON_HEIGHT_TALL: 'height-tall',
  SR_BUTTON_HEIGHT_EXTRA_TALL: 'height-extra-tall',
};

export const SR_BUTTON_FONT_SIZE_SMALL = 'SR_BUTTON_FONT_SIZE_SMALL';
export const SR_BUTTON_FONT_SIZE_MEDIUM = 'SR_BUTTON_FONT_SIZE_MEDIUM';
const SR_BUTTON_FONT_SIZE_TO_CLASSNAME_MAPPING = {
  SR_BUTTON_FONT_SIZE_SMALL: 'font-size-small',
  SR_BUTTON_FONT_SIZE_MEDIUM: 'font-size-medium',
};

const SrButton = ({
  children,
  disabled,
  onClick,
  type,
  minWidth,
  heightType,
  hasBoxShadow,
  theme,
  flexGrow,
  iconUrl,
  iconHeight,
  fontSizeType,
  wrapText,
  padding,
}) => {
  const buttonStyles = {
    minWidth: minWidth || null,
    flexGrow: flexGrow || null,
  };
  if (padding) {
    buttonStyles.padding = padding;
  }
  return (
    <button
      styleName={classnames(
        'SrButton',
        SR_BUTTON_THEME_TO_CLASSNAME_MAPPING[theme],
        SR_BUTTON_HEIGHT_TO_CLASSNAME_MAPPING[heightType],
        SR_BUTTON_FONT_SIZE_TO_CLASSNAME_MAPPING[fontSizeType],
        { hasBoxShadow, disabled, wrapText },
      )}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      style={buttonStyles}
    >
      {iconUrl ? (
        <SrFlex justify='center' align='center'>
          <SrBox marginRight='9px'>
            <img alt='button-icon' src={iconUrl} width='auto' height={iconHeight} />
          </SrBox>
          {children}
        </SrFlex>
      ) : children}
    </button>
  );
};

SrButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  minWidth: PropTypes.string,
  heightType: PropTypes.oneOf(Object.keys(SR_BUTTON_HEIGHT_TO_CLASSNAME_MAPPING)),
  hasBoxShadow: PropTypes.bool,
  theme: PropTypes.oneOf(SR_BUTTON_THEMES),
  flexGrow: PropTypes.string,
  iconHeight: PropTypes.string,
  iconUrl: PropTypes.string,
  fontSizeType: PropTypes.oneOf(Object.keys(SR_BUTTON_FONT_SIZE_TO_CLASSNAME_MAPPING)),
};

SrButton.defaultProps = {
  type: 'button',
  minWidth: '100%',
  iconHeight: '18px',
  heightType: SR_BUTTON_HEIGHT_MEDIUM,
  fontSizeType: SR_BUTTON_FONT_SIZE_MEDIUM,
};

SrButton.displayName = 'SrButton';

export default SrButton;
